"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJWT = void 0;
function isJWT(token) {
    if (typeof token !== 'string')
        return false;
    const splittedToken = token.split('.');
    if (splittedToken.length !== 3)
        return false;
    try {
        JSON.parse(decodeBase64(splittedToken[0]));
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.isJWT = isJWT;
function decodeBase64(s) {
    const e = {}, L = s.length, w = String.fromCharCode;
    let i, b = 0, c, x, l = 0, a, r = '';
    const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (i = 0; i < 64; i++) {
        e[A.charAt(i)] = i;
    }
    for (x = 0; x < L; x++) {
        c = e[s.charAt(x)];
        b = (b << 6) + c;
        l += 6;
        while (l >= 8) {
            ;
            ((a = (b >>> (l -= 8)) & 0xff) || x < L - 2) && (r += w(a));
        }
    }
    return r;
}
//# sourceMappingURL=jwt.js.map